import { type DownloadFormatType } from "hoxton-shared/enums/exports";

import { useDownloadHTMLVideo } from "@/composables/download/useDownloadHTMLVideo";
import { useDownloadHTMLZip } from "@/composables/download/useDownloadHTMLZip";
import { useDownloadFlashtalkingExcel } from "@/composables/download/useDownloadFlashtalkingExcel";
import { useDownloadAEVideo } from "@/composables/download/useDownloadAEVideo";
import type { TemplateType as TemplateTypeType } from "hoxton-types";
import { TemplateType } from "hoxton-shared/enums/masterTemplate";

export function useDownload() {
    const { computeQueryParams: computeQueryParamsVideo, resetDownloadOptions: resetVideoDownloadOptions } =
        useDownloadHTMLVideo();

    const {
        computeQueryParams: computeQueryParamsHTMLZip,
        resetDownloadOptions: resetDownloadOptionsHTMLZip,
        isButtonDisabled: isButtonDisabledHTMLZip
    } = useDownloadHTMLZip();

    const {
        computeQueryParams: computeFlashTalkingExcelParams,
        resetDownloadOptions: resetFlashTalkingExcelOptions,
        isButtonDisabled: isButtonDisabledFlashTalkingExcel
    } = useDownloadFlashtalkingExcel();

    const { isButtonDisabled: isButtonDisabledAEVideo, resetValues: resetAEVideoValues } = useDownloadAEVideo();

    function resetDownloadOptions() {
        resetDownloadOptionsHTMLZip();
        resetFlashTalkingExcelOptions();
        resetVideoDownloadOptions();
        resetAEVideoValues();
    }

    function computeQueryParams(downloadFormat: DownloadFormatType) {
        return {
            ...computeQueryParamsHTMLZip(downloadFormat),
            ...computeFlashTalkingExcelParams(downloadFormat),
            ...computeQueryParamsVideo(downloadFormat)
        };
    }

    function getIsButtonDisabled(platform: DownloadFormatType | "", templateType: TemplateTypeType) {
        if (platform === "") {
            return true;
        }

        if (templateType === TemplateType.AE) {
            return isButtonDisabledAEVideo.value;
        }

        if (templateType === TemplateType.HTML5) {
            return (
                isButtonDisabledHTMLZip.value?.[platform] ??
                isButtonDisabledFlashTalkingExcel.value?.[platform] ??
                false
            );
        }

        return false;
    }

    return {
        getIsButtonDisabled,
        resetDownloadOptions,
        computeQueryParams
    };
}
